import { Box, Table, TableContainer } from '@material-ui/core';
import { OrderDetails } from '@nemuru-eng/js-api-client';

import { Body } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/Body/Body';
import { SliderWarning } from '@/components/modules/Cart/components/OrderLines/components/OrderTable/components/SliderWarning';
import {
  columnsDesktop,
  columnsMobile,
} from '@/components/modules/Cart/components/OrderLines/components/OrderTable/constants/tableColumns';
import { CustomHeader } from '@/components/shared/components/CustomTable/CustomHeader';
import { useDefaultTable } from '@/components/shared/hooks/useDefaultTable';
import { useScreen } from '@/hooks/useScreen';

export const OrderTable = ({ orderDetails }: { orderDetails: OrderDetails }) => {
  const { isMobile } = useScreen();
  const tableElementId = 'table-container';
  const { isScrollable, classes, stickyCellStyle } = useDefaultTable({ tableElementId });

  return (
    <>
      <Box pt={isMobile ? 1 : 0}>
        <TableContainer id={tableElementId}>
          <Table>
            <CustomHeader
              tableProps={{ classes, stickyCellStyle }}
              columns={isMobile ? columnsMobile : columnsDesktop}
              fontProps={{ color: 'textPrimary' }}
            />
            <Body orderDetails={orderDetails} tableProps={{ classes, stickyCellStyle }} />
          </Table>
        </TableContainer>
        {isScrollable && (
          <>
            <SliderWarning />
          </>
        )}
      </Box>
    </>
  );
};
